import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=0045fd3c&scoped=true&"
import script from "./Fullscreen.vue?vue&type=script&lang=js&"
export * from "./Fullscreen.vue?vue&type=script&lang=js&"
import style0 from "./Fullscreen.css?vue&type=style&index=0&id=0045fd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045fd3c",
  null
  
)

export default component.exports